/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.33/esri/copyright.txt for details.
*/
const o=512,t=4096,c=8,e=.125;export{t as tileCoordSize,e as tileCoordinateScale,c as tilePixelRatio,o as tilePixelSize};
